module.exports = __webpack_public_path__ + "img/btc.d03784fb.png";